<template>
  <v-container fluid>
    <v-row class="mb-2">
      <v-col cols="12" lg="2" md="3">
        <v-btn tile color="primary" @click="load" :loading="loading" style="width:100%;">加载</v-btn>
      </v-col>
      <v-col cols="12" lg="2" md="3">
        <v-btn tile color="success" @click="save" :loading="loading" style="width:100%;">保存</v-btn>
      </v-col>
    </v-row>
    <v-textarea v-model="template" label="默认派车任务" :rows="rows" outlined></v-textarea>
  </v-container>
</template>
<script>
import _ from "underscore";
export default {
  name: "DispatchPlanTemplate",
  data() {
    return {
      loading: false,
      template: "",
      rows: 30,
    };
  },
  computed: {
  },
  components: {},
  watch: {},
  mounted() {
    let height = window.innerHeight - 150;
    this.rows = Math.ceil(height / 30);
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      let height = window.innerHeight - 150;
      this.rows = Math.ceil(height / 30);
    };
  },
  methods: {
    load() {
      this.loading = true;
      this.$api.doAPI("/dispatchplan/template/load").then((res) => {
        this.loading = false;
        if (res.code === 0) {
          this.template = res.data.template;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.loading = false;
        console.error(err);
      });
    },
    save() {
      this.$api.doAPI("/dispatchplan/template/save", { template: this.template }).then((res) => {
        if (res.code === 0) {
          this.load();
        } else {
          this.$alert(res.msg);
          this.loading = false;
        }
      }).catch((err) => {
        this.loading = false;
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped></style>